import { Injectable } from '@angular/core';
import { environment } from "@app/env";

@Injectable()
export class EnvService {

  constructor() {
  }

  isProd(): boolean {
    return environment === 'prod';
  }

  isStg(): boolean {
    return environment === 'stg';
  }

  isTest(): boolean {
    return environment === 'test';
  }

  isDev(): boolean {
    return environment === 'dev';
  }

}



// WEBPACK FOOTER //
// ./src/providers/env.service.ts